import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  user-select: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useCallback, useState, useEffect } from 'react';
import styled from 'styled-components';
import * as DateUtils from './dateUtils';
import DayPicker from './DayPicker';
import * as DateFns from 'date-fns/fp';
var Modifiers = DateUtils.Modifiers;
var DateRangeWrapper = styled.div(_templateObject());

var isSelectingFirstDay = function isSelectingFirstDay(from, to, day) {
  var isBeforeFirstDay = from && day < from;
  var isRangeSelected = !!(from && to);
  return !from || isBeforeFirstDay || isRangeSelected;
};

export var DateRangePicker = function DateRangePicker(_ref) {
  var _modifiers;

  var value = _ref.value,
      defaultValue = _ref.defaultValue,
      defaultCursorRange = _ref.defaultCursorRange,
      onChange = _ref.onChange,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate;

  var _useState = useState(value || defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      currentRange = _useState2[0],
      setCurrentRange = _useState2[1];

  var _currentRange = _slicedToArray(currentRange, 2),
      from = _currentRange[0],
      to = _currentRange[1];

  var _useState3 = useState(defaultCursorRange),
      _useState4 = _slicedToArray(_useState3, 2),
      cursorRange = _useState4[0],
      setCursorRange = _useState4[1];

  var _useState5 = useState(DateUtils.getInitialDate({
    maxDate: maxDate,
    minDate: minDate
  }, from)),
      _useState6 = _slicedToArray(_useState5, 2),
      month = _useState6[0],
      setMonth = _useState6[1];

  var modifiers = (_modifiers = {}, _defineProperty(_modifiers, Modifiers.SELECTED_RANGE_START, from), _defineProperty(_modifiers, Modifiers.SELECTED_RANGE_END, to), _defineProperty(_modifiers, Modifiers.SELECTED_RANGE, function (day) {
    return DateUtils.isDayInRange(day, currentRange, true);
  }), _defineProperty(_modifiers, Modifiers.HOVERED_RANGE, function (day) {
    return DateUtils.isDayInRange(day, cursorRange, true);
  }), _defineProperty(_modifiers, Modifiers.HOVERED_RANGE_START, function (day) {
    return cursorRange[0] && DateFns.isSameDay(day, cursorRange[0]);
  }), _defineProperty(_modifiers, Modifiers.HOVERED_RANGE_END, function (day) {
    return cursorRange[1] && DateFns.isSameDay(day, cursorRange[1]);
  }), _defineProperty(_modifiers, Modifiers.DISABLED, function (day) {
    return !DateUtils.isDayInRange(day, [minDate, maxDate]);
  }), _modifiers);
  var handleDayPickerChange = useCallback(function (e) {
    setMonth(e.target.value);
  }, []);
  var handleDayClick = useCallback(function (day, modifiers, e) {
    if (modifiers.disabled) {
      return;
    }

    var value;

    if (isSelectingFirstDay(from, to, day)) {
      value = [day, null];
      setCurrentRange(value);
      setCursorRange(value);
    } else {
      setCurrentRange(function (range) {
        return value = [range[0], day];
      });
      setCursorRange([null, null]);
    }

    onChange && onChange(_objectSpread({}, e, {
      target: _objectSpread({}, e.target, {
        value: value
      })
    }));
  }, [from, onChange, to]);
  var handleDayMouseEnter = useCallback(function (day) {
    if (cursorRange[0]) {
      setCursorRange(function (range) {
        return [range[0], day];
      });
    }
  }, [cursorRange]);
  useEffect(function () {
    if (Array.isArray(value) && value !== currentRange) {
      setCurrentRange(value);
    }
  }, [currentRange, value]);
  return (
    /*#__PURE__*/
    React.createElement(DateRangeWrapper, null,
    /*#__PURE__*/
    React.createElement(DayPicker, {
      numberOfMonths: 2,
      onChange: handleDayPickerChange,
      fromMonth: minDate,
      month: month,
      toMonth: maxDate,
      selectedDays: currentRange,
      modifiers: modifiers,
      onDayClick: handleDayClick,
      onDayMouseEnter: handleDayMouseEnter,
      canChangeMonth: true
    }))
  );
};
DateRangePicker.defaultProps = {
  defaultValue: [null, null],
  defaultCursorRange: [null, null],
  maxDate: DateUtils.getDefaultMaxDate(),
  minDate: DateUtils.getDefaultMinDate()
};